<div [ngClass]="containerClass">
    <label [ngClass]="labelClass" [for]="id">{{label}}</label>
    <div [ngClass]="inputClass">
        <div class="input-group input-group-merge" [ngClass]="{ 'is-invalid': invalid }">
            <div class="input-group-prepend" *ngIf="prependText">
                <span class="input-group-text">{{prependText}}</span>
            </div>
            <input type="number" class="form-control" [ngClass]="{ 'is-invalid': invalid }" [id]="id"
                [(ngModel)]='value' [placeholder]="placeholder" [disabled]="isDisabled" (blur)="onTouch()"
                [autocomplete]="'new-' + id">
            <div class="input-group-append" *ngIf="appendText">
                <span class="input-group-text">{{appendText}}</span>
            </div>
        </div>
        <div *ngIf="invalid && displayErrorMessage" class="invalid-feedback">
            <ng-container *ngIf="isRequired && errors?.required">{{label}} is required</ng-container>
            <ng-container *ngIf="errors?.min">{{errors?.min?.actual}} is lower than {{errors?.min?.min}}</ng-container>
            <ng-container *ngIf="errors?.max">{{errors?.max?.actual}} is larger than {{errors?.max?.max}}</ng-container>
            <ng-container *ngIf="errors?.isZero">{{label}} is zero</ng-container>
            <ng-container *ngIf="errors?.actionNotAllowed">Action is not allowed</ng-container>
        </div>
        <p class="mb-0" *ngIf="hint"><small class="text-muted">{{hint}}</small>
    </div>
</div>